import React, { useState, useEffect } from 'react';
import LegalPage from './LegalPage';

export default function CGV() {
  const [html, setHtml] = useState('');

  useEffect(() => {
    fetch('/legal-content/cgv.json')
      .then(r => r.text())
      .then(text => {
        const trimmed = text.trim();
        if (!trimmed || trimmed.startsWith('{')) {
          setHtml('<p style="color: rgba(255,255,255,0.4); font-style: italic;">Contenu à venir.</p>');
        } else {
          setHtml(trimmed);
        }
      })
      .catch(() => setHtml('<p style="color: rgba(255,255,255,0.4); font-style: italic;">Contenu à venir.</p>'));
  }, []);

  return <LegalPage title="Conditions Générales de Vente" htmlContent={html} />;
}